import React, { useCallback, useEffect, useState } from 'react'
import {
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from '@coreui/react-pro'
import Table from './Table'
import AddForm from './AddForm'
import AdminAnnouncementService from 'src/service/AdminAnnouncementService'

const AdminAnnouncement = () => {
  const [announcements, setAnnouncements] = useState([])
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState({})

  const fetchAnnouncements = useCallback(async () => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    try {
      const result = await AdminAnnouncementService.getAnnouncements(
        offset,
        itemsPerPage,
        activePage,
        params,
      )
      setAnnouncements(result.data)
    } catch (error) {
      console.error('Error fetching announcements:', error)
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter])

  useEffect(() => {
    fetchAnnouncements()
  }, [fetchAnnouncements])

  return (
    <CRow>
      <CAccordion activeItemKey={1} alwaysOpen>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <strong>Create Announcement</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <AddForm fetchAnnouncements={fetchAnnouncements} />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
      <CAccordion activeItemKey={1}>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <strong>Manage Announcements</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <Table
              announcements={announcements}
              setAnnouncements={setAnnouncements}
              fetchAnnouncements={fetchAnnouncements}
              setActivePage={setActivePage}
              setItemsPerPage={setItemsPerPage}
              setColumnFilter={setColumnFilter}
              setColumnSorter={setColumnSorter}
              itemsPerPage={itemsPerPage}
              activePage={activePage}
              columnFilter={columnFilter}
              columnSorter={columnSorter}
            />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
    </CRow>
  )
}

export default AdminAnnouncement
